import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop component ensures that when navigating to a new route,
 * the page scrolls to the top instead of maintaining the previous scroll position.
 */
export const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when pathname changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Use instant to avoid animation delay
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
